import { useEffect, useState, type RefObject } from 'react';

interface ImageBox {
  left: number;
  top: number;
  width: number;
  height: number;
  containerWidth: number;
  containerHeight: number;
}

const useImageBox = (
  imageRef: RefObject<HTMLImageElement | null>,
  containerRef: RefObject<HTMLDivElement | null>
): ImageBox => {
  const [imageBox, setImageBox] = useState<ImageBox>({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    containerWidth: 0,
    containerHeight: 0,
  });

  useEffect(() => {
    const updateBox = () => {
      const img = imageRef.current;
      const cont = containerRef.current;

      if (!img || !cont) return;

      const imgRect = img.getBoundingClientRect();
      const contRect = cont.getBoundingClientRect();

      setImageBox({
        left: imgRect.left - contRect.left,
        top: imgRect.top - contRect.top,
        width: imgRect.width,
        height: imgRect.height,
        containerWidth: contRect.width,
        containerHeight: contRect.height,
      });
    };

    updateBox();
    window.addEventListener('resize', updateBox);
    window.addEventListener('scroll', updateBox, true);
    const img = imageRef.current;

    img?.addEventListener('load', updateBox);

    return () => {
      window.removeEventListener('resize', updateBox);
      window.removeEventListener('scroll', updateBox, true);
      img?.removeEventListener('load', updateBox);
    };
  }, [imageRef, containerRef]);

  return imageBox;
};

export default useImageBox;
